import React, { useState, useEffect, useContext, useCallback } from "react";
import moment from "moment";
import { VizContext } from "./VizContext";
const ClockContext = React.createContext([{}, () => {}]);
window.scenesOnAir = [];

window.control_ws = null;

const ClockProvider = (props) => {
  const [ws, setWS] = useState(null);
  const [wsStatus, setWSStatus] = useState(-1);
  const [auto_clock, setAutoClock] = useState();
  const [homeScore, setHomeScore] = useState();
  const [awayScore, setAwayScore] = useState();
  const [period, setPeriod] = useState();
  const { hyperClock } = useContext(VizContext);

  useEffect(() => {
    connect();
  }, []);

  function connect() {
    console.log("Clock connecting to server");
    try {
      window.clock_ws = new WebSocket(hyperClock);
      setWS(window.clock_ws);
    } catch (err) {}
  }

  useEffect(() => {
    if (window.clock_ws) {
      let timeout;
      window.clock_ws.onopen = () => {
        setWSStatus(1);
        console.log("Rugby Control on open");
        clearInterval(window.clock_keep_alive);
        window.clock_keep_alive = setInterval(() => {
          window.clock_ws.send(
            JSON.stringify({
              keep_alive: Date.now(),
              group: window.id,
            })
          );
        }, 20000);
      };
      window.clock_ws.onmessage = (data) => {
        //console.log("Clock on message");
        try {
          let obj = JSON.parse(data.data);

          if (!obj.keep_alive) {
            setAutoClock(obj.hyperTime?.game?.time);
            setPeriod(obj?.hyperTime?.game?.period);
            setHomeScore(obj?.hyperTime?.score?.home);
            setAwayScore(obj?.hyperTime?.score?.away);
          }

          //console.log(obj);
        } catch (err) {
          console.error(err);
        }
      };
      window.clock_ws.onerror = (err) => {
        console.log("Clock on message", err);
        ws.close();
      };
      window.clock_ws.onclose = (data) => {
        setWSStatus(0);
        console.log("Clock on close");
        clearTimeout(timeout);
        clearInterval(window.clock_keep_alive);
        timeout = setTimeout(() => {
          connect();
        }, 1000);
      };
    }
  }, [ws]);

  return (
    <ClockContext.Provider
      value={{
        wsStatus,
        auto_clock,
        period,
        homeScore,
        setHomeScore,
        awayScore,
        setAwayScore,
      }}
    >
      {props.children}
    </ClockContext.Provider>
  );
};

export { ClockContext, ClockProvider };
